// extracted by mini-css-extract-plugin
export default {"details":"TransactionDetails_details__uYGSc","details1":"TransactionDetails_details1__Sl11q","pr":"TransactionDetails_pr__Rqw27"};